import { HanAccountColumns } from '@/backend/features/health-alerts/entities/Account';
import {
    UserDirectoryFilterParams,
    useUserDirectoryFilter,
} from '@juvare/contact-management/ui/features/user-directory/hooks/useUserDirectoryFilter';
import { useOverrideCredentialingUserDirectoryFilter } from '@juvare/credentialing/ui/hooks';
import { Filter } from '@juvare/platform-shared/features/storage';

export function useOverrideMapUserDirectoryFilter() {
    const useOverrideUserDirectoryFilter = (
        params: UserDirectoryFilterParams,
    ): {
        data?: Filter<HanAccountColumns>[];
        isLoading: boolean;
        error?: unknown;
    } => {
        const { data: accountData, error: accountError, isLoading: accountLoading } = useUserDirectoryFilter(params);

        const {
            data: credentialingData,
            error: credentialingError,
            isLoading: credentialingLoading,
        } = useOverrideCredentialingUserDirectoryFilter(params);

        if (accountLoading || credentialingLoading) {
            return { data: undefined, isLoading: true, error: undefined };
        }

        if (accountError || credentialingError) {
            return { data: undefined, isLoading: false, error: accountError || credentialingError };
        }

        return { data: [...(accountData ?? []), ...(credentialingData ?? [])], isLoading: false };
    };

    return { useOverrideUserDirectoryFilter };
}
